// extracted by mini-css-extract-plugin
module.exports = {"tdStyle":"tdStyle--errorField--gt8_nSz","tdText":"tdText--errorField--1pfbZ53"};